import { Description, Field as HField, Label, Switch as HSwitch } from '@headlessui/react';
import { ReactNode } from 'react';

export interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: ReactNode;
    description?: ReactNode;
    disabled?: boolean;
}

/** Row with the label left and the switch right; the whole row toggles. Never submits a form. */
export const Switch = ({ checked, onChange, label, description, disabled }: SwitchProps) => (
    <HField disabled={disabled} className="flex min-h-control cursor-pointer items-center justify-between gap-4 data-[disabled]:cursor-not-allowed data-[disabled]:opacity-60">
        <span className="flex flex-col">
            <Label className="cursor-pointer text-small font-medium text-strong">{label}</Label>
            {description && <Description className="text-caption text-muted">{description}</Description>}
        </span>
        <HSwitch
            type="button"
            checked={checked}
            onChange={onChange}
            className="group relative inline-flex h-[26px] w-11 shrink-0 items-center rounded-chip bg-control transition-colors duration-hover ease-snap data-[checked]:bg-inverse"
        >
            <span
                aria-hidden="true"
                className="size-[22px] translate-x-0.5 rounded-chip bg-on-inverse shadow-e1 transition-transform duration-hover ease-snap group-data-[checked]:translate-x-[20px]"
            />
        </HSwitch>
    </HField>
);
